import React, { useEffect, useState } from 'react';
import LoyaltyFlow from '@containers/ViewReceipt/loyaltyFlow';
import { getObjectValue } from '@utility/utills';
import { connect } from 'react-redux';
import PaymentTerminalReceiptScreen from './paymentTerminalReceiptScreen';

const PaymentTerminalReceipt = props => {
  const [paymentFlowType, setPaymentFlowType] = useState(2);
  const isLoyaltyEnabled = getObjectValue(
    () => props.auth.loyaltyInfo && props.auth.loyaltyInfo.supportsLoyalty,
    false
  );
  const isDefaultMode = getObjectValue(
    () =>
      !props.deviceInfo.deviceGroup ||
      [0].includes(props.deviceInfo.deviceGroup.startMode),
    false
  );
  useEffect(() => {
    if (isLoyaltyEnabled && isDefaultMode) {
      setPaymentFlowType(2);
    } else {
      setPaymentFlowType(3);
    }
  }, []);

  const handleSkipLoyalty = () => {
    setPaymentFlowType(3);
  };

  const handlePaymentFlowType = () => {
    switch (paymentFlowType) {
      case 2:
        return (
          <LoyaltyFlow
            {...props}
            paymentFlowType={paymentFlowType}
            handleSkipLoyalty={handleSkipLoyalty}
          />
        );
      case 3:
        return (
          <PaymentTerminalReceiptScreen
            {...props}
            paymentFlowType={paymentFlowType}
          />
        );
      default:
        return <div />;
    }
  };

  return <div className="col-12 h-100">{handlePaymentFlowType()}</div>;
};

const mapStateToProps = state => ({
  auth: state.oauth.authInfo,
  deviceInfo: state.oauth.deviceInformation,
});

export default connect(mapStateToProps, null)(PaymentTerminalReceipt);
